<template>
  <div class="dialog-wrap">
    <el-dialog
      title="教师选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="980px">
      <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
        <el-form-item label="教师名称" prop="keyword">
          <el-input v-model="query.keyword" size="mini" placeholder="输入教师名称/手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button class="submit" size="mini" @click="handleFormReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          min-width="160"
          align="center">
        </el-table-column>
        <el-table-column
          prop="avatar"
          label="头像"
          min-width="160"
          align="center">
          <template slot-scope="scope">
            <img class="avatar" :src="scope.row.avatar">
          </template>
        </el-table-column>
        <el-table-column
          prop="tags"
          label="标签"
          min-width="160"
          align="center">
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="160"
          align="center">
        </el-table-column>
        <el-table-column
          prop="wechat"
          label="微信号"
          min-width="160"
          align="center">
        </el-table-column>
        <el-table-column
          label="在线客服状态"
          width="120"
          align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.service_status == 1">在线</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teacherList } from '@/api/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    teachers: {
      type: Array,
      default: () => {return []}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query:  {
        subject: '',
        college: '',
        type: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          {label: '全部', value: ''},
          {label: '正常', value: '1'},
          {label: '下线', value: '0'}
        ],
        types: [
          {label: '全部', value: ''},
          {label: '统考', value: '1'},
          {label: '非统考', value: '0'}
        ],
      },
      results: [],
      selections: [],
      countSelections: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchTeacherList()
        this.countSelections = []
      }
    },
    teachers(val) {
      this.countSelections = val
    }
  },
  methods: {
    // 教师列表请求
    fetchTeacherList() {
      let params = {...this.query}
      teacherList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count

        this.$nextTick(this.setRowSelection)
      })
    },
    // 设置选中行
    setRowSelection() {
      if (this.results.length) {
        this.results.forEach(row => {
          if (this.teachers.find(item => item.id === row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          }
        })
      }
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchTeacherList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchTeacherList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchTeacherList()
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val
      this.diffSelection()
    },
    handleSubmit() {
      this.$emit('submit', {teachers: this.countSelections})
      this.handleClose()
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        subject: '',
        type: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      }
      this.$emit('close')
    },
    // 选中项差异化计算
    diffSelection() {
      let diffs = []
      // 减
      this.countSelections.forEach((item, index) => {
        if (!this.selections.find(v => v.id === item.id)) {
          if (this.results.find(v2 => v2.id === item.id)) {
            diffs.push(item)
          }
        }
      })
      if (diffs.length) {
        this.countSelections = this.countSelections.filter(item => !diffs.find(v => v.id === item.id))
      }
      // 加
      this.selections.forEach(item => {
        if (!this.countSelections.find(v => v.id === item.id)) {
          this.countSelections.push(item)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .search-wrap {
      margin-bottom: -10px;
    }
    .result {
      margin-top: 10px;

      .avatar {
        display: block;
        width: 48px;
        height: 48px;
        object-fit: cover;
        margin: 0 auto;
      }
    }
    .footer {
      margin-top: 10px;
    }
  }
</style>
